/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AuslandsbeschaeftigungInputs */



/**

* @param {_Field_AuslandsbeschaeftigungInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_auslandsbeschaeftigung = /** @type {((inputs?: _Field_AuslandsbeschaeftigungInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AuslandsbeschaeftigungInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beschäftigungsverhältnisse im Ausland")
});